import { MessageRetailerOrBrandButton, additionalDataRequiredForContactingRetailerOrBrandCTA } from "../../shared/instantAnswerUtils";
import { orderTermIsNet60 } from "../../utils/orderTermIsNet60";
import { orderWasAlreadyCharged } from "../../utils/orderWasAlreadyCharged";
import { getViewOrderInvoiceCTA } from "./shared";
export var CanceledItemsIA = function CanceledItemsIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(_context) {
      return INVOICE_UPDATES(strictLocalize);
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getDescription(context, strictLocalize);
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getViewOrderInvoiceC;
        return (_getViewOrderInvoiceC = getViewOrderInvoiceCTA(context, strictLocalize)) === null || _getViewOrderInvoiceC === void 0 ? void 0 : _getViewOrderInvoiceC.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getViewOrderInvoiceC2, _getViewOrderInvoiceC3;
        return (_getViewOrderInvoiceC2 = getViewOrderInvoiceCTA(context, strictLocalize)) === null || _getViewOrderInvoiceC2 === void 0 ? void 0 : (_getViewOrderInvoiceC3 = _getViewOrderInvoiceC2.getLink) === null || _getViewOrderInvoiceC3 === void 0 ? void 0 : _getViewOrderInvoiceC3.call(_getViewOrderInvoiceC2, context.brandOrder);
      }
    },
    secondaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _MessageRetailerOrBra;
        return (_MessageRetailerOrBra = MessageRetailerOrBrandButton(context, strictLocalize)) === null || _MessageRetailerOrBra === void 0 ? void 0 : _MessageRetailerOrBra.label;
      },
      onClickFunctionBuilder: function onClickFunctionBuilder(context) {
        var _MessageRetailerOrBra2;
        return (_MessageRetailerOrBra2 = MessageRetailerOrBrandButton(context, strictLocalize)) === null || _MessageRetailerOrBra2 === void 0 ? void 0 : _MessageRetailerOrBra2.onClick;
      }
    },
    additionalRequiredData: additionalDataRequiredForContactingRetailerOrBrandCTA()
  };
};
var INVOICE_UPDATES = function INVOICE_UPDATES(strictLocalize) {
  return strictLocalize({
    id: "sDN15A",
    defaultMessage: [{
      "type": 0,
      "value": "Factuurupdates voor geannuleerde artikelen"
    }]
  });
};
var getDescription = function getDescription(context, strictLocalize) {
  var brandOrder = context.brandOrder;
  if (!brandOrder) {
    return [CASE_FOR_OTHER_CONDITIONS(strictLocalize)];
  }
  if (orderTermIsNet60(brandOrder)) {
    return [CASE_WHEN_ORDER_HAS_NET60_TERMS(strictLocalize)];
  }
  if (orderWasAlreadyCharged(brandOrder)) {
    return [CASE_WHEN_ORDER_HAS_BEEN_CHARGED_ALREADY(strictLocalize)];
  }
  return [CASE_FOR_OTHER_CONDITIONS(strictLocalize)];
};
var CASE_WHEN_ORDER_HAS_NET60_TERMS = function CASE_WHEN_ORDER_HAS_NET60_TERMS(strictLocalize) {
  return strictLocalize({
    id: "dpscKg",
    defaultMessage: [{
      "type": 0,
      "value": "Aangezien je geselecteerde bestelling is geplaatst met een 60 dagen netto betalingstermijn, worden de gemelde artikelen verwijderd van je factuur en worden deze niet in rekening gebracht."
    }]
  });
};
var CASE_WHEN_ORDER_HAS_BEEN_CHARGED_ALREADY = function CASE_WHEN_ORDER_HAS_BEEN_CHARGED_ALREADY(strictLocalize) {
  return strictLocalize({
    id: "kLQyb8",
    defaultMessage: [{
      "type": 0,
      "value": "Aangezien je bestelling bij verzending in rekening is gebracht, storten we het bedrag van de gemelde artikelen terug op de kaart in ons bestand. Houd rekening met de gebruikelijke verwerkingstijd voordat de terugbetaling op je kaart staat."
    }]
  });
};
var CASE_FOR_OTHER_CONDITIONS = function CASE_FOR_OTHER_CONDITIONS(strictLocalize) {
  return strictLocalize({
    id: "ViIRmN",
    defaultMessage: [{
      "type": 0,
      "value": "Voor bestellingen die worden geplaatst met een 60 dagen netto betalingstermijn, worden de gemelde artikelen verwijderd van je factuur en worden deze niet in rekening gebracht. Voor bestellingen die al bij verzending in rekening zijn gebracht, storten we het bedrag van de gemelde artikelen terug op de kaart in ons bestand."
    }]
  });
};